import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import OBHero from './components/OBHero';
import OBProblem from './components/OBProblem';
import OBPaths from './components/OBPaths';
import OBTechnical from './components/OBTechnical';
import OBResourcesFaq from './components/OBResourcesFaq';

const ozelBulutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeOS Özel Bulut OS',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VergeOS Özel Bulut İşletim Sistemi: tüm veri merkezini tek platform altında birleştiren güvenli, ölçeklenebilir ve maliyet etkin çözüm.',
  url: `${SITE_URL}/ozel-bulut-os`,
};

export default function OzelBulutOSPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="Özel Bulut İşletim Sistemi | VergeOS Private Cloud OS"
        description="VergeOS Özel Bulut OS ile tüm veri merkezinizi tek platform altında birleştirin. Güvenli, ölçeklenebilir ve maliyet etkin özel bulut altyapısı."
        keywords="özel bulut işletim sistemi, private cloud OS, VergeOS, veri merkezi konsolidasyonu, özel bulut"
        canonicalPath="/ozel-bulut-os"
        jsonLd={ozelBulutJsonLd}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        <OBHero />
        <OBProblem />
        <OBPaths />
        <OBTechnical />
        <OBResourcesFaq />
      </main>
      <FooterSection />
    </div>
  );
}
